// These universities have implemented the cookie consent manager on their site.
// Keep this list in alphabetical order
// Make sure to sync this list with the popcard here:
// https://github.com/Unibuddy/popcard-ui/blob/a55484531c4d9fb6a7a773363aa0b3694206d061/client/machop/Utils/CookieConsentUtils.js

export const universitiesWithCookieConsentManager = [
    "arteveldehogeschool",
    "berlin-school-of-business-and-innovation",
    "bishop-s-university",
    "brunel-university-london",
    "careers-personal-development-staffordshire",
    "cphbusiness",
    "ecole-polytechnique",
    "erasmus-school-of-health-policy-and-management",
    "erasmus-school-of-history-culture-and-communication",
    "erasmus-school-of-law",
    "erasmus-school-of-philosophy",
    "erasmus-se",
    "erasmus-university-rotterdam",
    "essb",
    "hec",
    "hec-paris",
    "jacobs-university",
    "ktu-erasmus",
    "royal-holloway",
    "skema-business-school",
    "staffordshire-university",
    "study-in-finland",
    "tampere-school-of-applied-science",
    "tampere-university-of-applied-sciences",
    "technical-university-of-denmark",
    "the-american-university-of-rome",
    "thomas-more-university-of-applied-sciences",
    "tu-delft",
    "university-at-buffalo",
    "university-of-groningen",
    "university-of-strathclyde",
    "uwe-bristol",
    "zuyd",
];
